import React, { Component } from 'react';
import getData from './../../data-services/api';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { FieldArray } from 'formik';
import IconButton from '@material-ui/core/IconButton';
import Loader from '../../components/CustomLoader';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ImageGalleryTitle from '../../components/ImageGalleryTitle';
import './SuperAdmin.css';

const queryString = require('query-string');

export default class WorkshopDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Details: {},
            day: 1,
            userData: {},
            FilterActiveArticleData: [],
            isDisabled: !!queryString.parse(window.location.search).id,
            picture_showing_products: [],
            entire_class_making_articles: [],
            entire_class_finished_articles: [],
            geo_tagged_Location_pictures: [],
            other_pictures: [],
            loading: true,
        };
    }

    async componentDidMount() {
        //---------------- Save data if page refresh -------------------------------
        if (this.props.location.count === 1) {
            this.props.location.count = 2;
            localStorage.setItem(
                'Udata',
                JSON.stringify(this.props.location ? this.props.location : null)
            );
        }
        const userData = JSON.parse(localStorage.getItem('Udata'));

        //---------------- Artical Data-------------------------------
        const articlesData = JSON.parse(localStorage.getItem('articles'));
        const FilterActiveArticleData = articlesData.filter((item) => {
            return item.active__c === 't';
        });

        this.setState({
            FilterActiveArticleData: FilterActiveArticleData.map((article) => ({
                label: article.material_name__c + ' - ₹' + article.mrp__c,
                // value: article.sfid,
                value: article.material_name__c + ' - ₹' + article.mrp__c,
                data: article,
                id: article.id,
                sfid: article.sfid,
                pil_billing__c: article.pil_billing__c,
            })),
            articles: articlesData.map((article) => ({
                label: article.material_name__c + ' - ₹' + article.mrp__c,
                // value: article.sfid,
                value: article.material_name__c + ' - ₹' + article.mrp__c,
                data: article,
                id: article.id,
                sfid: article.sfid,
                pil_billing__c: article.pil_billing__c,
            })),
            userData: userData,
        });

        var heroku_id__c = this.props.location.heroku_id__c
            ? this.props.location.heroku_id__c
            : userData.heroku_id__c;
        var SFID = this.props.location.sfid ? this.props.location.sfid : userData.sfid;

        // var heroku_id__c = "20240104152100";
        // var SFID = "0065i00000KqpAMAAZ";

        const WorkshopDetailsQuery = `Select workshop.* , fcp.name as fcpname__c, CMDI_Name__c from salesforce.Opportunity workshop inner join salesforce.account fcp on workshop.accountid=fcp.sfid where workshop.heroku_id__c='${heroku_id__c}'`;
        const workshopArticlesDetailsQuery = `Select Id, SFId, workshop_heroku_id__c,Article__c, Quantity__c from salesforce.Workshop_Article__c where opportunity__heroku_id__c='${heroku_id__c}'`;
        const picture_showing_productsQuery = `select id, Name,Image_URL__c, Workshop_Heroku_Id__c, Workshop__c, day__c, type__c, photodatetime__c from Salesforce.Workshop_Photo__c where workshop__c='${SFID}' and day__c='${this.state.day}' and type__c='picture_showing_products'`;
        const entire_class_making_articlesQuery = `select id, Name,Image_URL__c, Workshop_Heroku_Id__c, Workshop__c, day__c, type__c, photodatetime__c from Salesforce.Workshop_Photo__c where workshop__c='${SFID}' and day__c='${this.state.day}' and type__c='entire_class_making_articles'`;
        const entire_class_finished_articlesQuery = `select id, Name,Image_URL__c, Workshop_Heroku_Id__c, Workshop__c, day__c, type__c, photodatetime__c from Salesforce.Workshop_Photo__c where workshop__c='${SFID}' and day__c='${this.state.day}' and type__c='entire_class_finished_articles'`;
        const geo_tagged_Location_picturesQuery = `select id, Name,Image_URL__c, Workshop_Heroku_Id__c, Workshop__c, day__c, type__c, photodatetime__c from Salesforce.Workshop_Photo__c where workshop__c='${SFID}' and day__c='${this.state.day}' and type__c='geo_tagged_Location_pictures'`;
        const other_picturesQuery = `select id, Name,Image_URL__c, Workshop_Heroku_Id__c, Workshop__c, day__c, type__c, photodatetime__c from Salesforce.Workshop_Photo__c where workshop__c='${SFID}' and day__c='${this.state.day}' and type__c='other_pictures'`;
        const AMMDUserQuery = `select id, sfid, name from salesforce.pidilite_user__c where type__c = 'AMMD'`;
        Promise.all([
            getData(WorkshopDetailsQuery),
            getData(workshopArticlesDetailsQuery),
            getData(picture_showing_productsQuery),
            getData(entire_class_making_articlesQuery),
            getData(entire_class_finished_articlesQuery),
            getData(geo_tagged_Location_picturesQuery),
            getData(other_picturesQuery),
            getData(AMMDUserQuery),
        ]).then(
            async ([
                WorkshopDetailsData,
                workshopArticlesDetailsData,
                picture_showing_productsData,
                entire_class_making_articlesData,
                entire_class_finished_articlesData,
                geo_tagged_Location_picturesData,
                other_picturesData,
                AMMDUserData,
                ...data
            ]) => {

                const getHPASchool = await getData(
                    `Select Id, SFId, Name from salesforce.Account where sfid='${
                        WorkshopDetailsData.result[0].hpa_school__c
                    }'`
                );
                this.setState({
                    Details: {
                        WorkshopDetailsData: {
                            ...WorkshopDetailsData.result[0],
                            articles: workshopArticlesDetailsData.result
                                ? workshopArticlesDetailsData.result.map((articleData, index) => {
                                      try {
                                          const metadata = this.state.articles.find(
                                              (r) => r.data.sfid === articleData.article__c
                                          ).data;

                                          return {
                                              id: articleData.id,
                                              type: 'EXISTING',
                                              data: articleData,
                                              quantity__c: articleData.quantity__c,
                                              article__c:
                                                  metadata.material_name__c +
                                                  '-' +
                                                  metadata.material_code__c,
                                              pil_billing__c: metadata.pil_billing__c,
                                          };
                                      } catch (e) {
                                          return {
                                              type: 'NEW',
                                          };
                                      }
                                  })
                                : [],
                            hpa_school__c_value: {
                                label: getHPASchool.result[0].name,
                                value: getHPASchool.result[0].id,
                                data: getHPASchool.result[0],
                            },
                        },
                        workshopArticlesDetailsData: workshopArticlesDetailsData.result,
                        AMMDUserData: AMMDUserData.result,
                    },
                    picture_showing_products: picture_showing_productsData.result
                        ? picture_showing_productsData.result.map((p) => ({
                              ...p,
                              id: p.id,
                              url: p.image_url__c,
                              type: p.workshop_type,
                              photodatetime__c: p.photodatetime__c,
                          }))
                        : [],
                    entire_class_making_articles: entire_class_making_articlesData.result
                        ? entire_class_making_articlesData.result.map((p) => ({
                              ...p,
                              id: p.id,
                              url: p.image_url__c,
                              type: p.workshop_type,
                              photodatetime__c: p.photodatetime__c,
                          }))
                        : [],
                    entire_class_finished_articles: entire_class_finished_articlesData.result
                        ? entire_class_finished_articlesData.result.map((p) => ({
                              ...p,
                              id: p.id,
                              url: p.image_url__c,
                              type: p.workshop_type,
                              photodatetime__c: p.photodatetime__c,
                          }))
                        : [],
                    geo_tagged_Location_pictures: geo_tagged_Location_picturesData.result
                        ? geo_tagged_Location_picturesData.result.map((p) => ({
                              ...p,
                              id: p.id,
                              url: p.image_url__c,
                              type: p.workshop_type,
                              photodatetime__c: p.photodatetime__c,
                          }))
                        : [],
                    other_pictures: other_picturesData.result
                        ? other_picturesData.result.map((p) => ({
                              ...p,
                              id: p.id,
                              url: p.image_url__c,
                              type: p.workshop_type,
                              photodatetime__c: p.photodatetime__c,
                          }))
                        : [],
                    loading: false,
                });
            }
        );
    }

    goBackPrev = () => {
        this.props.history.push({
            pathname: '/Workshoplist',
            SFID: this.state.userData.id,
            Type: this.state.userData.Type,
            count: 0,
        });
    };

    render() {
        const {
            Details,
            loading,
            picture_showing_products,
            entire_class_making_articles,
            entire_class_finished_articles,
            other_pictures,
            geo_tagged_Location_pictures,
        } = this.state;

        return (
            <>
                <AppBar position="static">
                    <Toolbar>
                        <Grid item xs={2} sm={2} md={2}>
                            <IconButton
                                color="inherit"
                                aria-label="Menu"
                                onClick={() => {
                                    this.goBackPrev();
                                }}
                            >
                                <ArrowBackIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={8} sm={8} md={8}>
                            <Typography variant="title" color="inherit" className="text-center">
                                Workshop Details
                            </Typography>
                        </Grid>
                    </Toolbar>
                </AppBar>
                {loading ? (
                    <Grid container alignItems="center" justify="center">
                        <Loader type="Audio" color="#00BFFF" height="50" width="50" />
                    </Grid>
                ) : (
                    <>
                        <Paper elevation={2} style={{ padding: 10, paddingTop: 20 }} square={true}>
                            <Grid container spacing={8}></Grid>
                            <Grid container spacing={8}>
                                <Grid item xs={12} md={4} style={{ paddingLeft: 10 }}>
                                    <Typography
                                        align="left"
                                        variant="body2"
                                        style={{ fontSize: 14, marginTop: 8 }}
                                    >
                                        FCP :{' '}
                                        <span className="superAdmin_values">
                                            {Details.WorkshopDetailsData.fcpname__c}
                                        </span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={4} style={{ paddingLeft: 10 }}>
                                    <Typography
                                        align="left"
                                        variant="body2"
                                        style={{ fontSize: 14, marginTop: 8 }}
                                    >
                                        Assigned CMDI :{' '}
                                        <span className="superAdmin_values">
                                            {Details.WorkshopDetailsData.cmdi_name__c}
                                        </span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={4} style={{ paddingLeft: 10 }}>
                                    <Typography
                                        align="left"
                                        variant="body2"
                                        style={{ fontSize: 14, marginTop: 8 }}
                                    >
                                        Assigned AMMD :{' '}
                                        <span className="superAdmin_values">
                                            {Details.WorkshopDetailsData.ammd_name__c}
                                        </span>
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid container spacing={8}>
                                <Grid item xs={12} md={4} style={{ paddingLeft: 10 }}>
                                    <Typography
                                        align="left"
                                        variant="body2"
                                        style={{ fontSize: 14, marginTop: 8 }}
                                    >
                                        Total Number of Participants per Day :{' '}
                                        <span className="superAdmin_values">
                                            {Details.WorkshopDetailsData.no_of_participants__c}
                                        </span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={4} style={{ paddingLeft: 10 }}>
                                    <Typography
                                        align="left"
                                        variant="body2"
                                        style={{ fontSize: 14, marginTop: 8 }}
                                    >
                                        Actual No. of Participants :{' '}
                                        <span className="superAdmin_values">
                                            {
                                                Details.WorkshopDetailsData
                                                    .actual_participants_count__c
                                            }
                                        </span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={4} style={{ paddingLeft: 10 }}>
                                    <Typography
                                        align="left"
                                        variant="body2"
                                        style={{ fontSize: 14, marginTop: 8 }}
                                    >
                                        Workshop Amount :{' '}
                                        <span className="superAdmin_values">
                                            {Details.WorkshopDetailsData.stamped_amount__c}
                                        </span>
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid container spacing={8}>
                                <Grid item xs={12} md={4} style={{ paddingLeft: 10 }}>
                                    <Typography
                                        align="left"
                                        variant="body2"
                                        style={{ fontSize: 14, marginTop: 8 }}
                                    >
                                        Category :{' '}
                                        <span className="superAdmin_values">
                                            {Details.WorkshopDetailsData.category__c}
                                        </span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={4} style={{ paddingLeft: 10 }}>
                                    <Typography
                                        align="left"
                                        variant="body2"
                                        style={{ fontSize: 14, marginTop: 8 }}
                                    >
                                        Art Avenue / school Name :{' '}
                                        <span className="superAdmin_values">
                                            {Details.WorkshopDetailsData.hpa_school__c_value.label}
                                        </span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={4} style={{ paddingLeft: 10 }}>
                                    <Typography
                                        align="left"
                                        variant="body2"
                                        style={{ fontSize: 14, marginTop: 8 }}
                                    >
                                        Tertiary Amount :{' '}
                                        <span className="superAdmin_values">
                                            {Details.WorkshopDetailsData.total_tertiary_by_app__c}
                                        </span>
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid container spacing={8}>
                                <Grid item xs={12} md={4} style={{ paddingLeft: 10 }}>
                                    <Typography
                                        align="left"
                                        variant="body2"
                                        style={{ fontSize: 14, marginTop: 8 }}
                                    >
                                        Expense Head :
                                        <span className="superAdmin_values">
                                            {Details.WorkshopDetailsData.expense_head__c === 'Other'
                                                ? ` Other - (${Details.WorkshopDetailsData.other_expense_head_name__c})`
                                                : Details.WorkshopDetailsData.expense_head__c}
                                        </span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={4} style={{ paddingLeft: 10 }}>
                                    <Typography
                                        align="left"
                                        variant="body2"
                                        style={{ fontSize: 14, marginTop: 8 }}
                                    >
                                        Workshop Start date :{' '}
                                        <span className="superAdmin_values">
                                            {Details.WorkshopDetailsData.start_date_time__c}
                                        </span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={4} style={{ paddingLeft: 10 }}>
                                    <Typography
                                        align="left"
                                        variant="body2"
                                        style={{ fontSize: 14, marginTop: 8 }}
                                    >
                                        Workshop End date :{' '}
                                        <span className="superAdmin_values">
                                            {Details.WorkshopDetailsData.end_date_time__c}
                                        </span>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                        <FieldArray
                            name="articles"
                            render={(arrayHelpers) => (
                                <div>
                                    {Details.WorkshopDetailsData.articles &&
                                    Details.WorkshopDetailsData.articles.length > 0
                                        ? Details.WorkshopDetailsData.articles.map(
                                              (article, index) => (
                                                  <div key={index}>
                                                      <Paper
                                                          key={index}
                                                          elevation={2}
                                                          style={{
                                                              padding: 10,
                                                          }}
                                                          square={true}
                                                      >
                                                          <Grid
                                                              container
                                                              alignItems="center"
                                                              justify="space-between"
                                                              style={{
                                                                  paddingLeft: 10,
                                                              }}
                                                          >
                                                              <Grid item xs={4}>
                                                                  <Typography
                                                                      align="left"
                                                                      variant="body2"
                                                                  >
                                                                      {index + 1}{' '}
                                                                  </Typography>
                                                              </Grid>
                                                              <Grid item xs={8}>
                                                                  {/* {index !== 0 ? (
                                                                <IconButton
                                                                    color="secondary"
                                                                    disabled={this.isDisabledAccess(
                                                                        "article",
                                                                        isDisabled
                                                                    )}
                                                                    onClick={async () => {
                                                                        await this.deleteArticleCMDI(article);
                                                                        arrayHelpers.remove(index);
                                                                    }} // remove a friend from the list
                                                                >
                                                                    <CloseIcon />
                                                                </IconButton>
                                                            ) : null} */}
                                                              </Grid>
                                                              <Grid item xs={3}>
                                                                  <Typography
                                                                      align="left"
                                                                      variant="body2"
                                                                  >
                                                                      SKU Name:
                                                                  </Typography>
                                                              </Grid>
                                                              <Grid item xs={9}>
                                                                  {/* <Async
                                                                    value={{
                                                                        value: article.article__c,
                                                                        label: article.article__c
                                                                    }}
                                                                    cacheOptions
                                                                    defaultOptions={FilterActiveArticleData}
                                                                    closeMenuOnSelect
                                                                    isDisabled
                                                                /> */}
                                                                  <Typography
                                                                      align="left"
                                                                      variant="body2"
                                                                      style={{
                                                                          fontSize: 14,
                                                                      }}
                                                                  >
                                                                      <span className="superAdmin_values">
                                                                          {article.article__c}
                                                                      </span>
                                                                  </Typography>
                                                              </Grid>
                                                              <Grid item xs={3}>
                                                                  <Typography
                                                                      align="left"
                                                                      variant="body2"
                                                                  >
                                                                      Quantity:
                                                                  </Typography>
                                                              </Grid>
                                                              <Grid item xs={9}>
                                                                  {/* <TextField
                                                                    name={`articles[${index}].quantity__c`}
                                                                    placeholder="No. of Pieces"
                                                                    disabled
                                                                    value={article.quantity__c}
                                                                    fullWidth
                                                                /> */}
                                                                  <Typography
                                                                      align="left"
                                                                      variant="body2"
                                                                      style={{
                                                                          fontSize: 14,
                                                                      }}
                                                                  >
                                                                      <span className="superAdmin_values">
                                                                          {article.quantity__c}
                                                                      </span>
                                                                  </Typography>
                                                              </Grid>
                                                          </Grid>
                                                      </Paper>
                                                  </div>
                                              )
                                          )
                                        : null}
                                </div>
                            )}
                        />
                        <Paper elevation={2} style={{ padding: 10, paddingTop: 20 }} square={true}>
                            <div className="row superAdmin_WorkshopImageBox">
                                {picture_showing_products && picture_showing_products.length > 0 ? (
                                    <>
                                        <div className="col-lg-4">
                                            <ImageGalleryTitle title="Picture Showing Products" />
                                            <div className="superadmin_workshopImages">
                                                {picture_showing_products.map((r, index) => (
                                                    <img
                                                        src={r.url}
                                                        alt="img"
                                                        style={{
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={() => {
                                                            this.setState({
                                                                isOpen: true,
                                                                photoIndex: index,
                                                            });
                                                        }}
                                                        className="m-2"
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    </>
                                ) : null}
                                {entire_class_making_articles &&
                                entire_class_making_articles.length > 0 ? (
                                    <>
                                        <div className="col-lg-4">
                                            <ImageGalleryTitle title="Picture of entire class making articles" />
                                            <div className="superadmin_workshopImages">
                                                {entire_class_making_articles.map((r, index) => (
                                                    <img
                                                        src={r.url}
                                                        alt="img"
                                                        style={{
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={() => {
                                                            this.setState({
                                                                isOpen: true,
                                                                photoIndex: index,
                                                            });
                                                        }}
                                                        className="m-2"
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    </>
                                ) : null}
                                {entire_class_finished_articles &&
                                entire_class_finished_articles.length > 0 ? (
                                    <>
                                        <div className="col-lg-4">
                                            <ImageGalleryTitle title="Picture of entire class holding finished articles" />
                                            <div className="superadmin_workshopImages">
                                                {entire_class_finished_articles.map((r, index) => (
                                                    <img
                                                        src={r.url}
                                                        alt="img"
                                                        style={{
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={() => {
                                                            this.setState({
                                                                isOpen: true,
                                                                photoIndex: index,
                                                            });
                                                        }}
                                                        className="m-2"
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    </>
                                ) : null}
                                {geo_tagged_Location_pictures &&
                                geo_tagged_Location_pictures.length > 0 ? (
                                    <>
                                        <div className="col-lg-4">
                                            <ImageGalleryTitle title="Geo tagged Location pictures" />
                                            <div className="superadmin_workshopImages">
                                                {geo_tagged_Location_pictures.map((r, index) => (
                                                    <img
                                                        src={r.url}
                                                        alt="img"
                                                        style={{
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={() => {
                                                            this.setState({
                                                                isOpen: true,
                                                                photoIndex: index,
                                                            });
                                                        }}
                                                        className="m-2"
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    </>
                                ) : null}
                                {other_pictures && other_pictures.length > 0 ? (
                                    <>
                                        <div className="col-lg-4">
                                            <ImageGalleryTitle title="Other Pictures" />
                                            <div className="superadmin_workshopImages">
                                                {other_pictures.map((r, index) => (
                                                    <img
                                                        src={r.url}
                                                        alt="img"
                                                        style={{
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={() => {
                                                            this.setState({
                                                                isOpen: true,
                                                                photoIndex: index,
                                                            });
                                                        }}
                                                        className="m-2"
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    </>
                                ) : null}
                                {Details.WorkshopDetailsData.artical_finalized_photo__c &&
                                Details.WorkshopDetailsData.artical_finalized_photo__c ? (
                                    <>
                                        <div className="col-lg-4">
                                            <ImageGalleryTitle title="Finalized Article Photo" />
                                            <div className="superadmin_workshopImages">
                                                <img
                                                    src={
                                                        Details.WorkshopDetailsData
                                                            .artical_finalized_photo__c
                                                    }
                                                    alt="img"
                                                    style={{
                                                        cursor: 'pointer',
                                                    }}
                                                    className="m-2"
                                                />
                                            </div>
                                        </div>
                                    </>
                                ) : null}
                            </div>
                        </Paper>
                    </>
                )}
            </>
        );
    }
}
